import React from 'react';
import { Grid } from '@material-ui/core';
import useRequest from '@hooks/useRequest';
import {
  CustomizedDialog,
  CustomizedTypography,
  CustomizedButton
} from '@components/Customized';
import { HelpOutlined } from '@material-ui/icons';
import useUserActionLog, {
  CapaActivityType,
  Enum_Action_Button_Enum
} from '@hooks/useUserActionLog';
import useStyles from './styles';
import { CapaQuotationServiceType } from '@generated/graphql';
import {
  DesignRequestStageEnum,
  RequestQueryString
} from '@routes/NewRequest/types';
import useQueryString from '@hooks/useQueryString';

interface MdGuideDialogProps {
  open: boolean;
  onClose: () => void;
}

const MdGuideDialog = (props: MdGuideDialogProps) => {
  const classes = useStyles();
  const { onMoveQueryString } = useQueryString<RequestQueryString>();
  const { onUpdateRfqInfo, initialState } = useRequest();
  const { onInsertUserActionLogOne } = useUserActionLog();

  return (
    <CustomizedDialog
      closeButton
      icon={<HelpOutlined />}
      title="도면이 없으신가요?"
      open={props.open}
      onClose={props.onClose}
      color="primary"
      maxWidth={476}
    >
      <Grid container>
        <CustomizedTypography className={classes.DialogTitle}>
          도면을 제작하는 <span>‘기구설계 서비스’</span>를 먼저 이용해 보세요!
        </CustomizedTypography>

        <CustomizedTypography className={classes.DialogSubtitle}>
          도면이 없다면 도면을 설계, 제작하는 기구설계서비스를 이용하 실 수
          있습니다.
        </CustomizedTypography>
      </Grid>

      <Grid container>
        <CustomizedButton
          color="primary"
          variant="contained"
          fullWidth
          className={classes.button}
          onClick={() => {
            onInsertUserActionLogOne(
              Enum_Action_Button_Enum.Button_RFQ_NoDrwaing_UseMD,
              CapaActivityType.ButtonClick
            );
            onUpdateRfqInfo({
              ...initialState,
              serviceType: CapaQuotationServiceType.Design
            });

            onMoveQueryString({
              stage: DesignRequestStageEnum.PROCESS_SELECT,
              process: CapaQuotationServiceType.MechanicalDesign,
              serviceType: CapaQuotationServiceType.Design
            });

            props.onClose();
          }}
        >
          도면 먼저 제작하기
        </CustomizedButton>
        <CustomizedButton
          color="primary"
          variant="outlined"
          fullWidth
          className={classes.button}
          onClick={() => {
            onInsertUserActionLogOne(
              Enum_Action_Button_Enum.Button_RFQ_NoDrwaing_AboutMD,
              CapaActivityType.ButtonClick
            );
            props.onClose();
            window.open(
              'https://capa.ai/blog/posts/%EC%A0%9C%ED%92%88-%EB%94%94%EC%9E%90%EC%9D%B8%EA%B3%BC-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%B2%AB%EA%B1%B8%EC%9D%8C%EC%9D%84-%EC%8B%9C%EC%9E%91%ED%95%98%EC%84%B8'
            );
          }}
        >
          기구설계 자세히 알아보기
        </CustomizedButton>
      </Grid>
    </CustomizedDialog>
  );
};

export default MdGuideDialog;
